import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="About PyOhio 2021" mdxType="Seo" />
    <h1 {...{
      "id": "about-pyohio"
    }}>{`About PyOhio`}</h1>
    <p>{`PyOhio is a non-profit annual Python community conference usually held in Columbus, OH. It is being held online for 2020-2021. It is free to attend and welcomes anyone with an interest in Python. Content ranges from beginner to advanced and is intended to be relevant to all types of Python users: students, software professionals, scientists, hobbyists, and anyone looking to learn more.`}</p>
    <p>{`This year’s event will consist of 5 and 10-minute talks and sprints.`}</p>
    <h2 {...{
      "id": "osu-open-source-club"
    }}>{`OSU Open Source Club`}</h2>
    <p>{`PyOhio is produced in partnership with the Ohio State University Open Source Club.`}</p>
    <h2 {...{
      "id": "the-pyohio-2021-organizing-team"
    }}>{`The PyOhio 2021 Organizing Team`}</h2>
    <p>{`Coming soon!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      